import React, { useEffect, useState } from "react"
import Button from "../components/Button"
import AuthCard from "../components/AuthCard"
import requests from "../api/requests"
import { errorSnackBar } from "../components/snackBarOptions"
import { useSnackbar } from "react-simple-snackbar"
import { useNavigate } from "react-router-dom"
import FormInput from "../components/FormInput"
import { faGlobe, faIdCard } from "@fortawesome/free-solid-svg-icons"
import { cpfMask, isCPFValid } from "../utils/cpf"

function CollectTaxIDScreen() {
  const [isLoading, setIsLoading] = useState(false)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)

  const navigate = useNavigate()

  useEffect(() => {}, [navigate])

  const [values, setValues] = useState({
    internal_tax_id_country: "BR",
    internal_tax_id: "",
  })

  const cpfInput = {
    id: 2,
    name: "internal_tax_id",
    type: "text",
    placeholder: "CPF",
    errorMessage: "Preencha com seu CPF válido",
    label: "CPF",
    required: true,
    autoFocus: true,
    icon: faIdCard,
    pattern: "\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2}",
    inputMode: "numeric",
    autoComplete: "off",
  }

  const nifInput = {
    id: 2,
    name: "internal_tax_id",
    type: "text",
    placeholder: "NIF",
    errorMessage: "Preencha com seu NIF válido",
    label: "NIF",
    required: true,
    autoFocus: true,
    icon: faIdCard,
    pattern: "\\d{9}",
    inputMode: "numeric",
    autoComplete: "off",
  }

  const otherInput = {
    id: 2,
    name: "internal_tax_id",
    type: "text",
    placeholder: "Documento de Identificação",
    errorMessage: "Preencha com seu documento de identificação válido",
    label: "Documento",
    required: true,
    autoFocus: true,
    maxLength: 30,
    icon: faIdCard,
    autoComplete: "off",
  }

  const selectInput = () => {
    switch (values.internal_tax_id_country) {
      case "BR": return cpfInput
      case "PT": return nifInput
      default:   return otherInput
    }
  }

  const inputs = [
    {
      id: 1,
      name: "internal_tax_id_country",
      type: "select",
      placeholder: "País",
      options: [
        { value: "BR", label: "🇧🇷 Brasil" },
        { value: "PT", label: "🇵🇹 Portugal" },
        { value: "OTHER", label: "🌍 Outros" },
      ],
      errorMessage: "Selecione o país",
      label: "País",
      required: true,
      icon: faGlobe,
      autoComplete: "off",
    },
    { ...selectInput() },
  ]

  const onChange = (e) => {
    if (e.target.name === "internal_tax_id") {
      switch (values.internal_tax_id_country) {
        case "BR":
          e.target.value = cpfMask(e.target.value)
          break
        case "PT":
          e.target.value = e.target.value.replace(/\D/g, "")
          break
        default:
          break
      }
    }

    if (e.target.name === "internal_tax_id_country") {
      setValues({ ...values, [e.target.name]: e.target.value, internal_tax_id: "" })
      return
    }

    setValues({ ...values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const data = {
        internal_tax_id_country: values.internal_tax_id_country,
        internal_tax_id: values.internal_tax_id,
      }

      if (values.internal_tax_id_country === "BR") {
        if (!isCPFValid(values.internal_tax_id)) {
          openErrorSnackbar("Preencha com um CPF válido")
          return
        }
        data.internal_tax_id = values.internal_tax_id.replace(/\D/g, "")
      }

      const req = await requests.updateTaxID(data)
      if (req.status === 204) {
        navigate("/")
      }
    } catch (error) {
      if (error.response?.status === 400) {
        switch (values.internal_tax_id_country) {
          case "BR":
            openErrorSnackbar("Preencha com um CPF válido")
            break
          case "PT":
            openErrorSnackbar("Preencha com um NIF válido")
            break
          default:
            openErrorSnackbar("Preencha o documento de identificação válido")
            break
        }
        return
      }
      openErrorSnackbar("Ocorreu um erro inesperado")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthCard>
      <h1>Atualize seu cadastro</h1>
      <h2>Informe seu país e número de identificação para continuar.</h2>
      <form noValidate autoComplete="off" onSubmit={handleSubmit}>
        {inputs.map((input) => (
          <FormInput
            key={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
          />
        ))}
        <Button text="Atualizar" isLoading={isLoading} />
      </form>
    </AuthCard>
  )
}

export default CollectTaxIDScreen
